// Checks if the gift recipient's phone number has the correct number of digits based on the country code prefix.
const shouldShowNumberError = (props) => {
  const { settings, promise } = props;
  const giftRecipientNumber = promise.gift_recipient_number || "";
  const [prefix, numberPart = ""] = giftRecipientNumber.split("-");
  const phoneNumberDigits = ["+966", "+971", "+962"].includes(prefix) ? 9 : 8;
  return (
    settings.enable_force_gift_name_number &&
    (!giftRecipientNumber || numberPart.length !== phoneNumberDigits)
  );
};

export { shouldShowNumberError };
